import { render, staticRenderFns } from "./ColSalvageStart.vue?vue&type=template&id=641bdec0&scoped=true"
import script from "./ColSalvageStart.vue?vue&type=script&lang=js"
export * from "./ColSalvageStart.vue?vue&type=script&lang=js"
import style0 from "./ColSalvageStart.vue?vue&type=style&index=0&id=641bdec0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641bdec0",
  null
  
)

export default component.exports